import Nullstack from 'nullstack';
export default function IconArrowRampLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-ramp-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "3",
    x2: "17",
    y2: "11.707"
  }), "   ", Nullstack.element("path", {
    d: "M13 7l4 -4l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M7 14l-4 -4l4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M17 21a11 11 0 0 0 -11 -11h-3"
  }), " ");
}